import { createFileRoute } from "@tanstack/react-router";
import { MediaChatBox } from "@/components/paid-media/chat/cards";
import type { PlaybookPlatform } from "@/constants/paid-media-playbook";

function parsePlaybookPlatform(value: unknown): PlaybookPlatform | undefined {
  if (value === "meta" || value === "google") return value;
  return undefined;
}

export const Route = createFileRoute("/dashboard/paid-media/_layout/chat")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    prompt: (search.prompt as string) || undefined,
    playbookPlatform: parsePlaybookPlatform(search.playbookPlatform),
  }),
});

function RouteComponent() {
  const { prompt, playbookPlatform } = Route.useSearch();
  return <MediaChatBox initialPrompt={prompt} initialPlaybookPlatform={playbookPlatform} />;
}
